import { actionCopyIt } from "./actionCopy";

export const inviteCopyIt = {
    reviewSetup: "Verificare la configurazione",
    organisationAndContact: "Organizzazione e contatto",
    addPatient: "Aggiungere un paziente",
    inviteByEmail: "Invitare via e-mail",
    shareQrCode: "Condividere il link / codice QR",
    inviteSent: "Invito inviato",
    inviteSentTo: (email) => `Invito inviato a ${email}`,
    loading: actionCopyIt.loading,
    justAMoment: "Un attimo...",
    patientEmailWillReceiveInstructions: (email) => `${email} riceverà un'e-mail con le istruzioni per iniziare.`,
    patientPhoneWillReceiveInstructions: (phone) => `${phone} riceverà un SMS con le istruzioni per iniziare.`,
    patientWillReceiveInstructions: "Il Suo paziente riceverà un'e-mail con le istruzioni per iniziare.",
    emailAndMobileHint: "Entrambi, se possibile.",
    emailOrPhoneRequired: "(oppure telefono obbligatorio)",
    mobileOrEmailRequired: "(oppure e-mail obbligatoria)",
    diariesAddedInLast7Days: (count) => `Negli ultimi 7 giorni ha aggiunto ${count} diari a Patient Watch.`,
    goToDiary: "Andare al diario",
    inviteAnotherPatient: "Invitare un altro paziente",
    whatWasInjected: "Prodotto iniettato",
    clinicians: "Clinici",
    referringClinician: "Medico inviante",
    injectingClinician: "Medico che esegue l'iniezione",
    operatingSurgeon: "Chirurgo operatore",
    therapist: "Terapista",
    injectionMethod: "Metodo di iniezione",
    questionnaires: "Questionari",
    clinicContact: "Contatto dell'ambulatorio",
    surgeryDetails: "Informazioni sull'operazione",
    injectionDetails: "Informazioni sull'iniezione",
    treatmentDetails: "Informazioni sul trattamento",
    consultationDetails: "Informazioni sul consulto",
    consultationName: "Nome del consulto",
    description: "Descrizione",
    clinician: "Clinico",
    consultingClinician: "Clinico consulente",
    consultingClinicianDescription: "Il clinico che ha effettuato il consulto",
    productDetails: "Informazioni sul prodotto",
    providingClinician: "Clinico prescrittore",
    providingClinicianDescription: "Il clinico che ha prescritto, fornito o configurato il prodotto",
    usageInstructions: "Istruzioni per l'uso",
    editInjectionDetails: "Modificare le informazioni sull'iniezione",
    editInjectionClinicians: "Modificare i clinici dell'iniezione",
    editSurgeryDetails: "Modificare le informazioni sull'operazione",
    editSurgeryClinicians: "Modificare i clinici dell'operazione",
    editShockwaveDetails: "Modificare le informazioni sulle onde d'urto",
    editShockwaveClinicians: "Modificare i clinici delle onde d'urto",
    editConsultationDetails: "Modificare le informazioni sul consulto",
    editConsultingClinician: "Modificare il clinico consulente",
    editProductDetails: "Modificare le informazioni sul prodotto",
    editProvidingClinician: "Modificare il clinico prescrittore",
    editClinicContact: "Modificare il contatto dell'ambulatorio",
    notSet: "Non definito",
    selected: "Selezionato",
    unknownForm: "Modulo sconosciuto",
    unknownSchedule: "Calendario sconosciuto",
    noSide: "Nessun lato",
    noOptionSelected: "Nessuna opzione selezionata",
    noSubstanceSelected: "Nessuna sostanza selezionata",
    noSiteSelected: "Nessun lato o area selezionati",
    email: "E-mail",
    enterEmail: "Inserire l'indirizzo e-mail",
    titleOptional: "Titolo (facoltativo)",
    firstNameOptional: "Nome (facoltativo)",
    lastNameOptional: "Cognome (facoltativo)",
    mobileNumber: "Cellulare",
    firstNamePlaceholder: "ad es. Sherlock",
    lastNamePlaceholder: "ad es. Holmes",
    selectPlaceholder: "Selezionare",
    sendInvite: "Inviare l'invito",
    sendingInvite: "Invio dell'invito…",
    inviteSentToast: "Invito inviato",
    existingPatient: "Paziente già presente",
    existingPatientAddDiary: "Aggiungeremo questo diario al suo account esistente.",
    existingUser: "Utente già presente",
    existingUserAddToOrganisation: "Lo aggiungeremo a questa organizzazione invece di creare un nuovo account.",
    existingSecretary: "Segretario già presente",
    existingSecretaryAddAsYours: "Lo aggiungeremo come Suo segretario per questa organizzazione.",
    diaryQuotaBlockedTitle: "Limite di diari raggiunto",
    diaryQuotaUsage: (used: number, limit: number) =>
        `Ha utilizzato ${used} diari su ${limit} per questo periodo di fatturazione.`,
    diaryQuotaBlockedDescription: "Passi a un piano superiore per invitare altri pazienti con diari.",
    diaryQuotaUpgradeCta: "Scegliere un piano",
    diaryQuotaOwnerUnresolved:
        "Non è stato possibile determinare la quota di diari del clinico interessato. Associ questo segretario a un clinico, oppure invii l'invito dopo aver effettuato l'accesso come tale clinico.",
    noTemplateSelected: "Nessun modello selezionato. Per prima cosa",
    createTemplate: "creare un modello",
    createTemplateFirst: ".",
    organisation: "Organizzazione",
    hospitalNumberOptional: "Numero di cartella ospedaliera (facoltativo)",
    enterNhsHospitalNumber: "Inserire il numero di cartella ospedaliera NHS",
    hospitalNumberDescription: "Consente di ritrovare questo paziente nelle Sue cartelle ospedaliere.",
    referenceDateLabel: "Data da cui contare i follow-up",
    referenceDateStartToday: "Inizia oggi",
    referenceDateAskPatient: "Lo indica il paziente",
    inviteMethodLabel: "Come il paziente riceve l'invito",
    inviteMethodSend: "Inviare un'e-mail o un SMS",
    inviteMethodShare: "Mostrare un codice QR o copiare un link",
    selectOrganisationToContinue: "Selezioni un'organizzazione per continuare.",
    selectContactToContinue: "Selezioni una persona di contatto per continuare.",
    doctorEmailSharedWithPatient:
        "Questa e-mail è condivisa con il paziente; faccia attenzione prima di comunicarla o di usarla qui.",
    currentUserEmailSharedWithPatient:
        "La sua e-mail sarà condivisa con i pazienti e inserita in copia nelle loro comunicazioni. Le consigliamo di aggiungere un'e-mail di assistenza generica, come la casella del reparto, come persona di contatto.",
    addContactPerson: "Aggiungi persona",
    personalContactEmailWarning: "Sembra un'e-mail personale e i pazienti la vedranno.",
    personalContactEmailAddContact: "Aggiunga un contatto generico",
    personalContactEmailAfterLink: "come info@clinic.com dalla pagina Team: è gratuito.",
    enterPhoneNumber: "Inserire il numero di telefono",
    backToSetup: "Tornare alla configurazione",
    backToPatients: "Tornare ai pazienti",
    patientInvite: "Invito del paziente",
    diaryQrCode: "Codice QR del diario",
    diaryQrDescription:
        "Condivida questo codice QR o questo link affinché i pazienti possano registrarsi sul telefono e iniziare questo diario. I dettagli di configurazione sono stati confermati nel passaggio precedente.",
    generatingInviteLink: "Generazione del link di invito…",
    failedToCreateInviteLink: "Creazione del link di invito non riuscita",
    hospitalOnTheInvite: "Struttura indicata sull'invito",
    changingOrganisationUpdatesLink: "Qualsiasi modifica aggiorna il link e il codice QR.",
    shownOnPatientSignupLink: "Visualizzato sul link di registrazione del paziente.",
    patientWillChooseOrganisation:
        "Il paziente sceglierà quindi la propria organizzazione al momento della registrazione.",
    hospitalNumber: "Numero di cartella ospedaliera",
    enterHospitalNumber: "Inserire il numero di cartella ospedaliera",
    requiredForNhsOrganisations: "Visualizzato per le organizzazioni che raccolgono un numero di cartella ospedaliera",
    copyLink: "Copiare il link",
    copyQrCode: "Copiare il codice QR",
    copyInviteLink: "Copiare il link di invito",
    invitePageTitle: "Invitare",
    roleAndOrganisation: "Ruolo e organizzazione",
    navInviteDescription: "Inviti un clinico, un paziente o un segretario su Patient Watch.",
    tabEmail: "E-mail",
    tabQrCode: "Codice QR",
    optionalSuffix: "(facoltativo)",
};
